import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { PPTParcelData } from 'egov-api';


export const addPPTParcelData = createSourcedAction(
    'Add PPT Parcel data',
    props<{ parcelsData: PPTParcelData[]}>()
);
